import { themeColors } from "../themeColors";
import React, { useEffect, useState } from "react";
import {
  getAgentProfile,
  getAgentIntroId,
} from "../services/v2/agentProfile";
import { useParams, useLocation } from "react-router-dom";
import BackButton from "@/components/Common/BackButton";
import BathroomIcon from "../images/v2/bathroom-icon.svg";
import Bathtub from "../images/v2/Bathtub.svg";
import Squarefeet from "../images/v2/Squarefeet.svg";
import Cardmoeny from "../images/v2/cardmoney.svg";
import WantAdMoreIcon from "../images/want-ad-more-icon.svg";
import MyWantadMap from "../images/my-wantad-map.png";
import Facebook from "../images/v2/facebook-icon.svg";
import instagram from "../images/v2/instagram-icon.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate } from "react-router-dom";
import { loggedInUser } from "../helpers/common";
import {
  getPropertyIcon,
  getTooltipText,
  getCombinedText,
} from "../helpers/getPropertyIcons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ShareYourAdModal from "../components/MemberWantAd/v2/ShareYourAdModal";
import { shareWantAdSocial } from "../services/v2/wantAdService";
import { pageURLs } from "@/constants";
import {
  wantAdBudgetValue,
  wantAdSqftValue,
} from "../helpers/v2/createWantAd";
import { usePremium } from "@/hooks";
import { useAppConfig } from "@/appConfig";
import { PageWrapper } from "@/components/PageWrapper";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import { useMLSAgentAtGitchaRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import { openModal } from "@/reducers/modals";
import { useDispatch } from "react-redux";

const AgentInfo = () => {

  const params = useParams();
  const { slug } = params;
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = location.state?.fromSettings || location.state?.canGoBack;
  const [apiData, setData] = useState([]);
  const [introductions, setIntroductions] = useState([]);
  const [showShareModal, setShareModal] = useState(false);
  const [shareAdDetails, setShareAdDetails] = useState();
  const [shareUrl, setShareUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [fbUrl, setFbUrl] = useState("");
  const [wantAdId, setWantAdId] = useState("");
  const userId = loggedInUser();
  const currentUserId = _.get(userId, "userInfo.userId", null);

  const { shouldToggleColor } = usePremium();

  const { flags } = useAppConfig();

  const generateShareLink = async () => {
    if (!wantAdId || !currentUserId) return;
    try {
      const fbPayload = {
        wantAdId: wantAdId,
        platform: "facebook",
      };
      const response = await shareWantAdSocial(fbPayload);
      setShareUrl(response?.result?.shareUrl || "");
      setFbUrl(response?.result?.facebookShareUrl || "");
      setImageUrl(response?.result?.imageUrl || "");
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    generateShareLink();
  }, [wantAdId]);
  //YOUTUBE URL
  function convertToEmbedUrl(youtubeUrl) {
    let videoId = "";
    const standardMatch = youtubeUrl.match(
      /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtube\.com\/shorts\/)([^&]+)/,
    );
    const shortMatch = youtubeUrl.match(/youtu\.be\/([^?]+)/);

    if (standardMatch) {
      videoId = standardMatch[1];
    } else if (shortMatch) {
      videoId = shortMatch[1];
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : false;
  }

  const renderTooltip = (PropertyTypeId, subPropertyTypeId, Buy_or_Rent) => {
    const tooltipText =
      Buy_or_Rent === 1
        ? getTooltipText(PropertyTypeId)
        : subPropertyTypeId && subPropertyTypeId.length > 0
          ? getCombinedText(subPropertyTypeId)
          : "No data available";

    return (
      <Tooltip
        id="button-tooltip"
        placement="bottom-start"
        className="custom-tooltip"
      >
        {tooltipText}
      </Tooltip>
    );
  };

  const getAgentInfo = async (inventoryId) => {
    await getAgentProfile(inventoryId)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        setData(responseResult?.data);
        if (response.errorCode === 0 && responseResult) {
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    if (slug) {
      getAgentInfo(slug);
    }
  }, [slug]);

  const handleNavigateToDetailPage = (slug) => navigate(`${pageURLs.wantAdDetails}/${slug}`);

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  const { redirectToBLSEnv } = useMLSAgentAtGitchaRedirect();

  const dispatch = useDispatch()

  const handleNavigateToDirectMessage = () => {

    if (shouldRestrictAgent) {
      return redirectToBLSEnv({
        path: `${pageURLs.directMessages}?id=${apiData?.UserId}`,
        onGitchaEnvFallback: null,
      });
    }

    if (!userId) {
      return dispatch(openModal({ name: 'loginModal' }))
    }

    navigate(`${pageURLs.directMessages}?id=${apiData?.UserId}`, {
      state: {
        agentName: apiData?.FirstName,
        agentId: apiData?.UserId,
        agentCompany: apiData?.Company,
        agentProfile: apiData?.Img,
        fromDM: true,
      },
    });
  };

  const handleClose = () => {
    setShareModal(false);
  };

  const hasBio = apiData?.Bio?.length > 0;

  return (
    <>
      <PageWrapper>
        <div className={"agent-info-container"}>
          {canGoBack && <BackButton className="mb-24 d-inline-block" />}
          {/* Header */}
          <div className="agent-header">
            <div>
              {apiData?.Img && (
                <img
                  src={apiData.Img}
                  className="agent-header__img"
                  alt="Profile"
                />
              )}
            </div>
            <div>
              <div className="agent-header__name d-flex align-items-center">
                {/* name and pro badge */}
                {apiData?.FirstName} {apiData?.LastName}
                {flags.proBadge && apiData?.isPremiumAgent && (
                  <span className="agent-header__badge text-uppercase ms-1">
                    Pro
                  </span>
                )}
              </div>
              <div className="lic-info-label">Lic: #{apiData?.licenseNo}</div>
              <div className="agent-info-label">Agent @ {apiData?.Company}</div>
              <div className="d-flex flex-column agent-contact">
                {/* <a className="agent-contact__mail">{apiData?.Company}</a> */}
                {/* logo */}
                {apiData?.logoUrl && (
                  <div className="brand-logo">
                    <img src={apiData.logoUrl} alt="agent-logo" />
                  </div>
                )}
                {/* contact number */}
                <a className="agent-contact__phone">{apiData?.Phone}</a>
              </div>
            </div>
          </div>

          {/* About Section */}
          <div className="agent-about">
            {hasBio ? (
              <>
                <div className="agent-about__heading">
                  About {apiData?.FirstName}
                </div>
                <div className="agent-about__details">{apiData?.Bio}</div>
              </>
            ) : null}
            {/* <div className="agent-about__details">Lic:{apiData?.licenseNo}</div> */}
            <div className="agent-buttons d-flex align-items-center">
              {apiData?.isPremiumAgent && (
                <button
                  className="agent-buttons__buybtn"
                  onClick={() => {
                    const linkToShare =
                      process.env.REACT_APP_BUYERLISTING_SERVICE_BASE_URL +
                      "/form/" +
                      `${params?.slug}`;
                    window.open(linkToShare, "_blank"); // Open the page in a new tab
                  }}
                >
                  Buyer Listing Form
                </button>
              )}
              <button
                className="agent-buttons__directbtn ms-2"
                onClick={handleNavigateToDirectMessage}
              >
                Direct Message
              </button>
            </div>
          </div>
          <div className="about-section-border"></div>

          {/* Active Buyers Section */}
          <div className="about-buyers">
            <div className="about-buyers__heading">
              {apiData?.FirstName
                ? `${apiData.FirstName}'s Active Buyers: ${apiData.activeWantAdCount}`
                : "Active Buyers"}
            </div>
            <div className="about-buyers__cards">
              {Array.isArray(apiData?.activeWantAds) &&
                apiData.activeWantAds.length > 0 ? (
                apiData.activeWantAds.map((activeWantAd) => (
                  <div
                    className="about-buyers-cardinfo pointer"
                    key={activeWantAd.Want_ad_Id}
                    onClick={() => {
                      handleNavigateToDetailPage(activeWantAd.slug);
                    }}
                  >
                    <div>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip(
                          activeWantAd?.PropertyTypeId,
                          activeWantAd?.subPropertyTypeId,
                          activeWantAd?.Buy_or_Rent,
                        )}
                      >
                        <img
                          src={getPropertyIcon(activeWantAd?.PropertyTypeId)}
                          alt={getPropertyIcon(activeWantAd?.PropertyTypeId)}
                          className="about-property-tile property-tile"
                        />
                      </OverlayTrigger>
                      <img
                        src={activeWantAd?.Location_Img || MyWantadMap}
                        alt="location-image"
                        className="w-100 about-buyer-img"
                        onError={(e) => {
                          e.currentTarget.src = MyWantadMap;
                        }}
                      />
                    </div>
                    <div className="about-card">
                      <div className="d-flex justify-content-between align-items-center side-nav-wrap">
                        <div className="about-card__label tex-uppercase">
                          {activeWantAd?.Buy_or_Rent === 1
                            ? "LOOKING TO BUY"
                            : "LOOKING TO RENT"}
                        </div>
                        {/* TODO: check with api response and share card fields */}
                        {userId && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <Dropdown>
                              <Dropdown.Toggle
                                id="dropdown-basic"
                                variant=""
                                align="end"
                              >
                                <img src={WantAdMoreIcon} alt="More Options" />
                              </Dropdown.Toggle>

                              <Dropdown.Menu
                                className={`dpdown-menu-style`}
                                align="end"
                              >
                                <Dropdown.Item
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const transformedAdDetails = {
                                      minBdgt: activeWantAd?.Budget_mn,
                                      maxBdgt: activeWantAd?.Budget_mx,
                                      sqFtMin: activeWantAd?.Sqft_mn,
                                      sqFtMax: activeWantAd?.Sqft_mx,
                                      minLtSz: activeWantAd?.LotSz_mn,
                                      maxLtSz: activeWantAd?.LotSz_mx,
                                      noBedRm: activeWantAd?.Bedrooms,
                                      noBathRm: activeWantAd?.Bathrooms,
                                      adType:
                                        activeWantAd?.Buy_or_Rent === 1
                                          ? "BUY"
                                          : "RENT",
                                      adTitle: activeWantAd?.Title_Text,
                                    };

                                    setShareModal(true);
                                    setShareAdDetails(transformedAdDetails);
                                    setWantAdId(activeWantAd?.Want_ad_Id);
                                  }}
                                >
                                  Share
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                      <div className="about-card__title">
                        {activeWantAd.Title_Text}
                      </div>
                      <div className="about-card__location">
                        {activeWantAd.Location}
                      </div>
                      {/* <div className=" ">{activeWantAd.sqft}</div> */}
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <img src={BathroomIcon} alt="baithroom-img"></img>
                          <div className="ms-1 about-card-items">
                            {activeWantAd.Bedrooms}
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <img src={Bathtub} alt="baithroom-img"></img>
                          <div className="ms-1 about-card-items">
                            {activeWantAd.Bathrooms}
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <img src={Squarefeet} alt="baithroom-img"></img>
                          <div className="ms-1 about-card-items">
                            {wantAdSqftValue(
                              _.get(activeWantAd, "Sqft_mn", ""),
                              _.get(activeWantAd, "Sqft_mx", ""),
                            )}{" "}
                            sqft
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <img src={Cardmoeny} alt="baithroom-img"></img>
                          <div className="ms-1 about-card-items">
                            {wantAdBudgetValue(
                              _.get(activeWantAd, "Budget_mn", ""),
                              _.get(activeWantAd, "Budget_mx", ""),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="">No active buyers available.</div>
              )}
            </div>
          </div>

          {/* Testimonials Section */}
          {apiData?.clientTestimonial &&
            Array.isArray(apiData?.clientTestimonial) &&
            apiData?.clientTestimonial.some(
              (testimonial) => testimonial.trim() !== "",
            ) && (
              <>
                <div className="about-section-border"></div>
                <div className="client-testimonials">
                  <div className="client-testimonials__head">
                    Client Testimonials
                  </div>
                  {apiData?.clientTestimonial.map(
                    (testimonial, index) =>
                      testimonial.trim() !== "" && ( // Ensure to render only non-empty testimonials
                        <div className="mb-3" key={index}>
                          <div className="client-content">{testimonial}</div>
                          {/* <div className="client-author">{testimonial.author}</div> */}
                        </div>
                      ),
                  )}
                </div>
              </>
            )}

          {/* More About Section */}
          {(apiData?.websiteUrl ||
            apiData?.facebookUrl ||
            apiData?.instagramUrl ||
            apiData?.youtubeUrl) && (
              <>
                <div className="about-section-border"></div>
                <div className="agent-section">
                  <div className="agent-section__name">
                    More about {apiData?.FirstName}
                  </div>

                  {apiData?.websiteUrl && (
                    <div className="agent-section__email">
                      <a
                        href={apiData.websiteUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {apiData.websiteUrl}
                      </a>
                    </div>
                  )}

                  <div className="agent-section__contactus">
                    {apiData?.facebookUrl && (
                      <a
                        href={apiData.facebookUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={Facebook} alt="Facebook" />
                      </a>
                    )}
                    {apiData?.instagramUrl && (
                      <a
                        href={apiData.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={instagram} alt="Instagram" />
                      </a>
                    )}
                  </div>
                  {apiData?.youtubeUrl &&
                    convertToEmbedUrl(apiData?.youtubeUrl) && (
                      <iframe
                        className="agent-youtube-embed"
                        width="430"
                        height="240"
                        src={convertToEmbedUrl(apiData.youtubeUrl)}
                      ></iframe>
                    )}
                </div>
              </>
            )}
        </div>
      </PageWrapper>
      {showShareModal && (
        <ShareYourAdModal
          show={showShareModal}
          onHide={handleClose}
          isSideCard={true}
          shareLink={shareUrl}
          fbLink={fbUrl}
          imageLink={imageUrl}
          adDetails={shareAdDetails}
          isWantAdCreated={false}
          AdType={_.get(shareAdDetails, "adType", "") === "BUY" ? 1 : 2}
          isAdTypeIsLand={_.get(shareAdDetails, "prprtyType", "") === 6}
          adTypeBasedOnProperty={
            _.get(shareAdDetails, "prprtyType", "") === 6
              ? LOT_LAND
              : _.get(shareAdDetails, "adType", "")
          }
        />
      )}
    </>
  );
};

export default AgentInfo;
